export const OCC_ENDPOINTS = {
  articlesSearch: '/articles/search',
  articleDetail: '/articles/${articleCode}',
  articles: '/articles',
  saveRating: '/articles/rate',
};
